export abstract class RegexFormatter {
  static emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  /**
   * Check if the email is valid
   * @param email - The email to check
   * @returns true if the email is valid, false otherwise
   * @example
   * ```ts
   * const email = 'test@example.com'
   * const isValid = RegexFormatter.isValidEmail(email) // true
   * ```
   */
  static isValidEmail(email: string): boolean {
    return this.emailRegex.test(email)
  }
}
